export default {
  blue: "#36B9D3",
  orange: "#F89E48",
  red: "#D60069",
};
